<div class="row justify-content-md-center no-gutters greyBgBody marL10">
    <div class="col-12">
        <div class="row no-gutters">
            <div class="col-12 whiteBg">
                <div #searchFieldsHeight>
                    <h5 class="sectionTitleBig">
                        Subscription Search <span class="searchDrownArrow"
                                                  *ngIf="seaerchAreaDownArrow" (click)="searchAreaExpand()">
                            <i class="fa fa-chevron-down"></i>
                        </span><span class="searchDrownArrow"
                                     *ngIf="seaerchAreaUpArrow" (click)="searchAreaCollapse()">
                            <i class="fa fa-chevron-up"></i>
                        </span>
                    </h5>
                    <div class="row" *ngIf="searchAreaFields">
                      <div class="col-4">
                        <label for="subscriptionIdSearch">Subscription ID</label>
                        <input type="text" placeholder="" id="subscriptionIdSearch" [(ngModel)]="selectedSubscriptionId"
                               (ngModelChange)="onChangeOfInputFields()" (keyup.enter)="getSearchData()" />
                      </div>
                      <!-- Company Name/Organization Autocomplete -->
                      <div class="col">
                        <label for="typeahead-format">Company Name/Organization</label>
                        <input placeholder="" id="typeahead-format" type="text" class="form-control" name="companyName"
                               [(ngModel)]="selectedCompanyName" [ngbTypeahead]="searchCompanies"
                               [resultFormatter]="formatMatches" [inputFormatter]="formatMatches"
                               (selectItem)="typeaheadOnSelect($event)" #companyName="ngModel"
                               (ngModelChange)="onChangeOfInputFields();validateFields()" (keyup.enter)="getSearchData()" />
                        <span *ngIf="isCompName" class="errorMsgLabel">
                          {{compNameErrorMsg}}
                        </span>
                      </div>
                      <div class="col-4 editSessionDate">
                        <label>Subscription Date Range</label>
                        <div class="row">
                          <div class="form-group col">
                            <div class="input-group">
                              <input class="form-control inputValFontSizeLineHeight" placeholder="mm-dd-yyyy" name="dp"
                                     [(ngModel)]="startDate" ngbDatepicker #d1="ngbDatepicker"
                                     (dateSelect)="onStartDateSelect($event)" autocomplete="off"
                                     (ngModelChange)="onStartDateSelect($event); onChangeOfInputFields()"
                                     (click)="d1.toggle()" (keyup.enter)="getSearchData()">
                              <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar2" (click)="d1.toggle()"
                                        type="button">
                                  <i class="fa fa-calendar"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group col">
                            <div class="input-group">
                              <input class="form-control inputValFontSizeLineHeight" placeholder="mm-dd-yyyy" [(ngModel)]="endDate"
                                     (dateSelect)="onEndDateSelect($event)" name="dp"
                                     (ngModelChange)="onEndDateSelect($event); onChangeOfInputFields()"
                                     ngbDatepicker #d2="ngbDatepicker" [minDate]="minDate" (click)="d2.toggle()"
                                     autocomplete="off" (keyup.enter)="getSearchData()">
                              <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar2" (click)="d2.toggle()"
                                        type="button">
                                  <i class="fa fa-calendar"></i>
                                </button>
                              </div>
                              <span class="errorMessage" *ngIf="IsDateInvalid">
                                {{invalidDateErrorMsg}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <label for="subscriptionAdminSearch">Subscription Admin</label>
                        <input type="text" placeholder="" id="subscriptionAdminSearch" [(ngModel)]="selectedSubscriptionAdmin" (ngModelChange)="onChangeOfInputFields()"
                               (keyup.enter)="getSearchData()" />

                      </div>

                      <div class="col-4">
                        <label for="select-subscriptionType">Subscription Type</label>
                        <div class="dropdown-container">
                        <select class="form-control custom-select inputValFontSizeLineHeight" [(ngModel)]="selectedSubscriptionType" id="select-subscriptionType" name="SubscriptionType" (keyup.enter)="getSearchData()" (ngModelChange)="onChangeOfInputFields()">
                            <option *ngFor="let item  of SubscriptionType" value={{item.name}}>{{(item.name)}}</option>
                          </select>
                          <span class="dropdown-arrow">
                            <i class="fa fa-chevron-up"></i>
                            <i class="fa fa-chevron-down"></i>
                          </span>
                          </div>
                        </div>
                        <div class="col-2">
                          <label>Session Audience </label>
                          <div class="row rowAddedBorder no-gutters searchSubscriptionRow">
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="ExternalClient"
                                     (ngModelChange)="setAudienceCheckboxValue('ExternalClient', $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Client
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="ExternalNonClient"
                                     (ngModelChange)="setAudienceCheckboxValue('ExternalNonClient', $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Non-Client
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="MixedAudience"
                                     (ngModelChange)="setAudienceCheckboxValue('MixedAudience', $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Mixed Audience
                            </div>

                          </div>
                        </div>
                        <div class="col-2">
                          <label>Status </label>
                          <div class="row rowAddedBorder no-gutters searchSubscriptionRow">
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="ApprovalPending"
                                     (ngModelChange)="setStatusCheckboxValue('Approval Pending', $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />To Review
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsActive"
                                     (ngModelChange)="setStatusCheckboxValue('Active', $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Active
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsHold"
                                     (ngModelChange)="setStatusCheckboxValue('Hold', $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Hold
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsInactive"
                                     (ngModelChange)="setStatusCheckboxValue('Inactive', $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Inactive
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsCancelled"
                                     (ngModelChange)="setStatusCheckboxValue('Cancelled', $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Cancelled
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <label for="subscriptionNameSearch">Subscription Name</label>
                          <input type="text" id="subscriptionNameSearch" placeholder="" [(ngModel)]="selectedSubscriptionName"
                                 (ngModelChange)="onChangeOfInputFields()" (keyup.enter)="getSearchData()" />
                        </div>
                      </div>
                </div>
                <div class="row separateLineTop">
                    <div class="col-6 txtLightColor">
                        <div *ngIf="showTable">{{totalRecords}} records</div>
                        <div *ngIf="showTable">Maximum of 1000 Results will display</div>
                    </div>

                    <div class="col text-right">
                        <button *ngIf="totalRecords > 0 && seaerchAreaDownArrow" type="button" class="clickBtn"
                                (click)="searchAreaExpand()" [disabled]="!enableSearchBtn || isCompName">
                            Modify search
                        </button>
                        <button type="button" *ngIf="totalRecords == 0 || !seaerchAreaDownArrow" class="clickBtn"
                                (click)="getSearchData()" [disabled]="!enableSearchBtn || isCompName">
                            Search
                        </button>
                        <button type="reset" class="clickBtn marL20" (click)="resetSearch()"
                                [disabled]="!enableClearBtn">
                            Clear
                        </button>
                        <div class="text-right marT20">
                            <button type="button" class="clickBtn" [disabled]="!isEnableExportBtn"
                                    (click)="exportData()">
                                Export Results
                            </button>
                        </div>
                    </div>

                </div>

                <div class="searchDataTable" [style.max-height]="searchGridHeight">
                    <app-loader-icon *ngIf="showLoaderIcon"></app-loader-icon>
                    <app-smart-data-grid *ngIf="showTable" [sampleColumns]="sampleColumns" [sampleData]="sampleData"
                                         [allowCheckbox]="allowCheckbox" [iseventRegistered]="iseventRegistered"
                                         [allowPagination]="allowPagination" [isClientSidePagination]="isClientSidePagination"
                                         [isSubscriptionModule]="isSubscriptionModule" [totalRecord]="totalRecords"
                                         [pageSize]="totalRecords"  >
                    </app-smart-data-grid> <!-- (n) test and remove these (checkboxChangeEvent)="onCheckboxChange($event)" (handlePageChangeEvent)="updateListData($event)" (informParentComponent)="onRowSelect($event)" -->
                </div>

            </div>
        </div>
    </div>
</div>
